import HelloSection from "./components/HelloSection/HelloSection";
import ServicesSection from "./components/ServicesSection/ServicesSection";
import MapSection from "./components/MapSection/MapSection";
import AdvSection from "./components/AdvSection/AdvSection";
import ContactSection from "./components/ContactSection/ContactSection";

const MainPage = () => {


    return (
        <>
            <HelloSection/>
            <ServicesSection/>
            <MapSection/>
            <AdvSection/>
            <ContactSection/>
        </>
    );
};

export default MainPage;